// extracted by mini-css-extract-plugin
export default {"new-button":"New__new-button___scxA0"};